import React from 'react';
import styles from './BrandTrustSection.module.css';

// Logo Imports
import logo1 from '../../../assets/images/clients/Black Jack Logo.jpg';
import logo2 from '../../../assets/images/clients/DENIS PARK.jpeg';
import logo3 from '../../../assets/images/clients/IZARO.jpeg';
import logo4 from '../../../assets/images/clients/SPARK LOOGO.jpeg';
import logo5 from '../../../assets/images/clients/h s 1.jpeg';
import logo6 from '../../../assets/images/clients/h s 2.jpeg';
import logo7 from '../../../assets/images/clients/munkey logo yellow png.png';
import logo8 from '../../../assets/images/clients/tejoo 1.jpeg';
import logo9 from '../../../assets/images/clients/tejoo 2.jpeg';
import logo10 from '../../../assets/images/clients/5gjeans_logo.png';
import logo11 from '../../../assets/images/clients/FLU Writing Style nd Logo.png';
import logo12 from '../../../assets/images/clients/happyboy_logo.png';
import logo13 from '../../../assets/images/clients/hellobrother final logo.png';
import logo14 from '../../../assets/images/clients/toxy_logo_color.png';
import logo15 from '../../../assets/images/clients/vipin.png';

const brandLogos = [
  { id: 1, src: logo1, name: 'Black Jack' },
  { id: 2, src: logo2, name: 'Denis Park' },
  { id: 3, src: logo3, name: 'Izaro' },
  { id: 4, src: logo4, name: 'Spark' },
  { id: 5, src: logo5, name: 'HS 1' },
  { id: 6, src: logo6, name: 'HS 2' },
  { id: 7, src: logo7, name: 'Munkey' },
  { id: 8, src: logo8, name: 'Tejoo 1' },
  { id: 9, src: logo9, name: 'Tejoo 2' },
  { id: 10, src: logo10, name: '5G Jeans' },
  { id: 11, src: logo11, name: 'FLU' },
  { id: 12, src: logo12, name: 'Happy Boy' },
  { id: 13, src: logo13, name: 'Hello Brother' },
  { id: 14, src: logo14, name: 'Toxy' },
  { id: 15, src: logo15, name: 'Vipin' }
];

const BrandTrustSection = () => {
  const itemCount = brandLogos.length;

  return (
    <section className={styles.section} aria-label="Brands that trust us">
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.trustStats}>
             <span>NATIONWIDE RETAIL PARTNERS</span>
          </div>
          <h2 className={styles.title}>Trusted Wholesale Network</h2>
          <p className={styles.subtitle}>Our partners represent the elite multi-brand outlets of India.</p>
        </div>
        {/* 3D Circular CSS Carousel */}
        <div className={styles.carouselStage}>
          <div className={styles.carouselRing}>
            {brandLogos.map((logo, index) => (
              <div 
                key={logo.id} 
                className={styles.carouselItem}
                style={{
                  '--index': index,
                  '--total': itemCount
                }}
              >
                <div className={styles.logoCard}>
                  <img 
                    src={logo.src} 
                    alt={logo.name} 
                    className={styles.logoImg} 
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandTrustSection;
